import { Chip } from "@mui/material"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import { PRICE_CHANGE_SUBMISSION_STATUS_CHIP_CLASS } from "../constants/priceChangeHistoryLabelMap"

import type { PriceChangeSubmissionStatus } from "@/graphql/codegen/graphql"
import { PRICE_CHANGE_SUBMISSION_STATUS_LABELS } from "@/screens/Pricing/constants"

interface PriceChangeHistoryStatusCellProps {
  status: PriceChangeSubmissionStatus
}

export const PriceChangeHistoryStatusCell: FC<PriceChangeHistoryStatusCellProps> = ({ status }) => (
  <Chip
    className={twMerge("h-6 rounded-sm text-xs font-medium", PRICE_CHANGE_SUBMISSION_STATUS_CHIP_CLASS[status])}
    label={PRICE_CHANGE_SUBMISSION_STATUS_LABELS[status]}
    size='small'
  />
)
